import { Component } from '@angular/core';
import { MessageInterface } from '../../message/message.service';

@Component({
  selector: 'iv-message',
  templateUrl: './iv-message.component.html',
  styleUrls: ['./iv-message.component.scss']
})
export class IvMessageComponent {
  messageData: MessageInterface | undefined;

  onClose(): void {
    this.messageData = undefined;
  }

  show({ title, message, type, code, traceid }: MessageInterface): void {
    this.messageData = { title, message, type, code, traceid };

    if (type !== 'error') {
      setTimeout(() => {
        this.messageData = undefined;
      }, 3000);
    }
  }
}
